import React, { FC, useEffect, useRef, useState } from 'react'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import FhirLoader from '../../FhirLoader'
import useQuery from '../../../hooks/location/useQuery'
import Loader from '../../Loader'

type ValidateEmailProps = {
  memberDetails: any;
  goBack: () => void;
  validateResults: boolean;
  isLoading: boolean;
  isError: boolean;
  error: string;
  sendNewCodeResult: any;
  sendNewCode: () => void;
  onSubmit: (values: any) => void;
}

const ValidateEmail: FC<ValidateEmailProps> = ({ memberDetails, isError, error, validateResults, sendNewCodeResult, sendNewCode, onSubmit, isLoading }) => {
  const [showAlertState, setShowAlertState] = useState({ show: true, variant: 'info', message: '' })
  const [newCodeClicked, setNewCodeClicked] = useState(false)

  const query = useQuery()
  const code = query.get('code')
  const hasSubmitted = useRef(false)
  useEffect(() => {
    if (!code || hasSubmitted.current) return

    hasSubmitted.current = true

    onSubmit({ code })
  }, [code, onSubmit])

  useEffect(() => {
    if (validateResults === false || isError) {
      setShowAlertState({
        show: true,
        variant: 'danger',
        message: isError ? error : 'Unable to verify email.'
      })
    }
  }, [validateResults, isError])

  useEffect(() => {
    if (newCodeClicked && sendNewCodeResult.isSuccess) {
      setShowAlertState({
        show: true,
        variant: 'success',
        message: 'Sent new code'
      })
    }
  }, [newCodeClicked, sendNewCodeResult.isSuccess])

  const handleSendNewCode = () => {
    setNewCodeClicked(true)
    sendNewCode()
  }

  if (isLoading) {
    return <Loader
      message="Validating email..."
    />
  }

  return (
    <>
      <h4>Email Validation</h4>
      {
        !isLoading ? showAlertState.show && (
          <Alert variant={showAlertState.variant}>
            {
              isError ? <span dangerouslySetInnerHTML={{ __html: showAlertState.message }} /> : showAlertState.message || `Please check the email sent to ${memberDetails.email} for verifying the email you entered.`
            }
            {
              showAlertState.message === 'Unable to verify email.' && (
                <Button onClick={handleSendNewCode} variant="outline-danger" className='ms-3'>
                  {
                    sendNewCodeResult.isLoading ? (
                      <FhirLoader small={true} />
                    ) : 'Send New Code'
                  }
                </Button>
              )
            }
          </Alert>
        ) : null
      }
    </>
  )
}

export default ValidateEmail